import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.roofMaterialTypeState || initialState;

export const selectRoofMaterialTypeLoading = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.loading
);

export const selectRoofMaterialTypeList = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.list
);

export const selectRoofMaterialTypeMeta = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.meta
);

export const selectRoofMaterialTypePage = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.page
);

export const selectRoofMaterialTypePerPage = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.isAddModalOpen
);

export const selectRoofMaterialTypeForm = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.form
);

export const selectRoofMaterialTypeSaving = createSelector(
  [selectDomain],
  (roofMaterialTypeState) => roofMaterialTypeState.saving
);

export const selectCanSubmitRoofMaterialType = createSelector(
  [selectRoofMaterialTypeForm],
  (form) => Boolean(form.materialTypeDesc.trim())
);
